// ======================================================================
// File Name       : ContentQuestionAttributeContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap';
import {
  fetchQuestionAttributeList,
  bulkRegistration,
  exportQuestionAttributeIdListCSV,
} from '../../actions/content/ContentQuestionAttributeAction';
import { SELECT_TARGET_DATA } from '../../constants/index';
import ContentQuestionAttribute from '../../components/content/ContentQuestionAttribute';
import ContentEachQuestionAttributeList from '../../components/content/ContentEachQuestionAttributeList';
import ContentQuestionAttributeBulkRegistration from '../../components/content/ContentQuestionAttributeBulkRegistration';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';

class ContentQuestionAttributeContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recordNum: 0,
      questionAttributeIdList: [],
      eachQuestionAttributeList: [],
      showEachQuestionAttributeListModal: false,
      isBulkRegistration: false,
      bulkFileName: null,
      uploadFile: null,
      doneRegister: false,
    };

    this.showEachQuestionAttributeList = this.showEachQuestionAttributeList.bind(this);
    this.cancelDlg = this.cancelDlg.bind(this);
    this.showBulkRegistration = this.showBulkRegistration.bind(this);
    this.cancelBulkRegistration = this.cancelBulkRegistration.bind(this);
    this.handleBulkFileChange = this.handleBulkFileChange.bind(this);
    this.bulkRegistration = this.bulkRegistration.bind(this);
    this.exportQuestionAttributeIdListCSV = this.exportQuestionAttributeIdListCSV.bind(this);
  }

  componentWillMount() {
    this.getQuestionAttributeListData();
  }

  getQuestionAttributeListData() {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
    };
    this.props.dispatch(fetchQuestionAttributeList(param));
  }

  showEachQuestionAttributeList(index) {
    const { questionAttributeIdList } = this.props;
    const eachQuestionAttributeList = questionAttributeIdList[index].eachQuestionAttributeList;
    this.setState({ showEachQuestionAttributeListModal: true, eachQuestionAttributeList });
  }

  exportQuestionAttributeIdListCSV() {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.CSV,
    };
    this.props.dispatch(exportQuestionAttributeIdListCSV(param));
  }

  cancelDlg() {
    this.setState({ showEachQuestionAttributeListModal: false, eachQuestionAttributeList: [] });
  }

  showBulkRegistration() {
    this.setState({ isBulkRegistration: true });
  }

  cancelBulkRegistration() {
    this.setState({ isBulkRegistration: false, bulkFileName: null, uploadFile: null });
  }

  handleBulkFileChange(event) {
    if (event.target.files.length !== 0) {
      const bulkFileName = event.target.files[0].name;
      this.setState({ uploadFile: event.target.files[0], bulkFileName });
    }
  }

  bulkRegistration() {
    const param = {
      uploadFile: this.state.uploadFile,
    };
    this.props.dispatch(bulkRegistration(param));
  }

  componentWillReceiveProps(nextProps) {
    const { questionAttributeIdList, recordNum, doneRegister } = nextProps;
    if (doneRegister) {
      this.setState({
        uploadFile: null,
        bulkFileName: null,
        isBulkRegistration: false,
        doneRegister: false,
      });
      this.getQuestionAttributeListData();
    }
    this.setState({
      questionAttributeIdList,
      recordNum,
    });
  }

  render() {
    const { questionAttributeIdList, zipFile, recordNum, isBulkRegistration } = this.state;
    const headerName = isBulkRegistration ? '問題属性情報の一括登録' : '問題属性情報の一覧';
    return (
      <Form className='form-horizontal'>
        {!isBulkRegistration &&
          <CustomLink
            className="margin-right-7 url-list"
            to={Path.CONTENT_QUESTION_LIST}
            text="問題管理に戻る"
            icon="bi bi-chevron-left"
          />
        }
        <Header name={headerName} />
        {isBulkRegistration &&
        <p className="padding-left-15"><span className="required">(※)</span> 指定していない問題属性は削除対象となりますので、登録対象となる問題属性全てをCSVファイルに指定してください。
        </p>}
        {!isBulkRegistration
          ? <ContentQuestionAttribute
            questionAttributeIdList={questionAttributeIdList}
            zipFile={zipFile}
            showEachQuestionAttributeList={this.showEachQuestionAttributeList}
            showBulkRegistration={this.showBulkRegistration}
            exportQuestionAttributeIdListCSV={this.exportQuestionAttributeIdListCSV}
          />
          : <ContentQuestionAttributeBulkRegistration
            bulkFileName={this.state.bulkFileName}
            handleBulkFileChange={this.handleBulkFileChange}
            cancelBulkRegistration={this.cancelBulkRegistration}
            bulkRegistration={this.bulkRegistration}
          />}
        <ContentEachQuestionAttributeList
          showModal={this.state.showEachQuestionAttributeListModal}
          eachQuestionAttributeList={this.state.eachQuestionAttributeList}
          onCancel={this.cancelDlg}
        />
      </Form>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { questionAttributeIdList, recordNum, doneRegister } = state.question;
  return { ...{ questionAttributeIdList, recordNum, doneRegister } };
};

export default connect(mapStateToProps)(ContentQuestionAttributeContainer);
